// Must run before anything that generates IDs (see the file for why).
import "./src/lib/crypto-polyfill";
import "./src/lib/sentry";
import "expo-router/entry";
